import React, { FC, PropsWithChildren, ReactNode } from 'react';

import { Stack } from '../../Stack';


export const ButtonsContainer: FC<PropsWithChildren<ReactNode>> = ({ children }) => (
    <Stack
        direction='row'
        spacing={3}
        mt={2}
        width='100%'
    >
        {children}
    </Stack>
);
